export const SET_SHOPPINGS = 'setShoppings'
export const SET_REPORTS = 'setReports'
export const FETCH_START = 'fetchShoppingsStart'
export const FETCH_END = 'fetchShoppingsEnd'
export const SET_SHOPPING = 'setShopping'